// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--3jUsc","svg":"styles-module--svg--Nv4Yn"};